import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { Tabs } from "src/app/common/tabs/tabs.enum";
import { TabsService } from "src/app/common/tabs/tabs.service";
import { ModalService } from "src/app/services/modal.service";
import { TilgangService } from "src/app/services/tilgang.service";
import { TabSideBaseClass } from "../../common/tab-side/tab-side.component";
import { ServerSystem, ServerMedSystemerForSystem, KoblingerService } from "../../koblinger/koblinger.service";
import { ServerType } from "./servertype.enum"
import { throwError} from "rxjs";


@Component({
  selector: "app-itsystemtjenester-tab",
  templateUrl: "./itsystemserver-tab.component.html"

})
export class ItsystemServerTabComponent extends TabSideBaseClass<ServerMedSystemerForSystem> {

  tabName(): Tabs {
    return Tabs.server;
  }

  ServerType = ServerType;

  constructor(tabsService: TabsService, service: KoblingerService, tilgangService: TilgangService, modal: ModalService, route: ActivatedRoute, router: Router) {
    super(tabsService, service, tilgangService, modal, route, router);
  }

  
  loaderObservable(service: KoblingerService, id: number): Observable<ServerMedSystemerForSystem[]> {
    return this.service.getServerMedSystemerForSystem(id);
  }

  pageLinkAccess(service: TilgangService): Observable<boolean> {
    return of(true);
  }

  
  removeObservable(service: KoblingerService, item: ServerMedSystemerForSystem): Observable<object> {
    // Kommentert ut 16.april 2026. Skal ikke ha denne funksjonaliteten her lenger.
    //return service.removeServerSystemForSystem(item.serverId, item.systemId);
    return throwError(() => new Error('removeObservable er avviklet'));
  }

  
  kobleTil(): void {
    /*
    // Kommentert ut 16.april 2026. Skal ikke ha denne funksjonaliteten her lenger.
    this.modal.velgServer().then(server => {

      if (this.liste.some(t => t.serverId === server.serverId)) {
        this.modal.warning(`${server.navn} er allerede koblet til system`, "Kobling feilet");
        return;
      }

      const item: ServerSystem = { systemId: this.id, serverId: server.serverId };

      
      this.service.postServerSystemForSystem(item).toPromise().then(() => {
        this.modal.success("", "Server koblet til system");
        this.load();
      });     
    });
    */
  }
  



}
